import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { EditToggleService } from '../../shared/services/edit-toggle.service';
import { CommentType } from '../models/airport-comment.model';
import { MatDialog, MatDialogConfig, MatSnackBar } from '@angular/material';
import { EditRemarkComponent } from '../edit-remark/edit-remark.component';
import { DeleteRemarkComponent } from '../delete-remark/delete-remark.component';
import { Airport } from '../models/airport.model';
import { AirportService } from '../airport.service';
/**
 * Remark types that should be displayed in this component
 */
var REMARK_TYPES = [
    CommentType.General,
    CommentType.Facility,
    CommentType.Miscellaneous
];
var RemarksComponent = /** @class */ (function () {
    function RemarksComponent(_toggleService, _snackBar, _editRemarkDialog, _deleteRemarkDialog, _airportService) {
        this._toggleService = _toggleService;
        this._snackBar = _snackBar;
        this._editRemarkDialog = _editRemarkDialog;
        this._deleteRemarkDialog = _deleteRemarkDialog;
        this._airportService = _airportService;
    }
    RemarksComponent.prototype.ngOnInit = function () {
        var _this = this;
        this._toggleService.toggleEmitter.subscribe(function (isOn) {
            _this.editModeSet = isOn;
        });
    };
    Object.defineProperty(RemarksComponent.prototype, "additionalRemarks", {
        get: function () {
            return this.airport.airportComments
                .filter(function (comment) { return REMARK_TYPES.includes(comment.commentType) && comment.commentRef !== 'WhyHere'
                && comment.text != null && comment.text.toLowerCase().trim() !== 'none'; })
                .sort(function (n1, n2) { return n1.sourceId - n2.sourceId; });
        },
        enumerable: true,
        configurable: true
    });
    RemarksComponent.prototype.reloadAirport = function (identifier) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(identifier, true)];
                    case 1:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    RemarksComponent.prototype.openEditRemarkDialog = function (index) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var dialogConfig, ERROR_MSG, defaultRemark, dialogRef;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                dialogConfig = new MatDialogConfig();
                ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
                dialogConfig.disableClose = true;
                dialogConfig.autoFocus = true;
                dialogConfig.width = '60%';
                defaultRemark = {
                    commentType: 'General',
                    commentRef: 'Notes'
                };
                dialogConfig.data = {
                    airID: this.airport.airportId,
                    id: null,
                    isNew: false,
                    remark: defaultRemark
                };
                index == null ? dialogConfig.data.isNew = true : dialogConfig.data.remark = this.additionalRemarks[index];
                dialogConfig.data['airID'] = this.airport.airportId;
                dialogConfig.width = '60%';
                dialogRef = this._editRemarkDialog.open(EditRemarkComponent, dialogConfig);
                dialogRef.afterClosed().subscribe(function (isUpdated) {
                    if (!isUpdated) {
                        return;
                    } // required to handle backdrop click.
                    if (isUpdated.cancelBtnClicked) {
                        return;
                    }
                    // isUpdated.success will be false if there is an error during any of the api calls.
                    if (isUpdated.success) {
                        if (isUpdated.isNew) {
                            _this.airport.airportComments.push(isUpdated.remark);
                            _this._snackBar.open('Remark', 'Added', {
                                duration: 2000
                            });
                        }
                        else {
                            _this._snackBar.open('Remark', 'Updated', {
                                duration: 2000
                            });
                        }
                        _this.reloadAirport(_this.airport.identifier);
                    }
                    else {
                        _this._snackBar.open(ERROR_MSG, 'Error', {
                            duration: 6000
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    RemarksComponent.prototype.deleteRemark = function (index) {
        var _this = this;
        var dialogConfig = new MatDialogConfig();
        var ERROR_MSG = 'An error has occurred, please try back later, or call 1-800-USA-AOPA if the error persists.';
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            airportId: this.airport.airportId,
            remarkId: this.additionalRemarks[index].id
        };
        var dialogRef = this._deleteRemarkDialog.open(DeleteRemarkComponent, dialogConfig);
        dialogRef.afterClosed().subscribe(function (isUpdated) {
            if (!isUpdated) {
                return;
            } // required to handle backdrop click.
            if (isUpdated.cancelBtnClicked) {
                return;
            }
            // isUpdated.success will be false if there is an error during any of the api calls.
            if (isUpdated.success) {
                _this._snackBar.open('Remark', 'Deleted', {
                    duration: 2000
                });
                // this.airport.airportComments.splice(index, 1);
                _this.reloadAirport(_this.airport.identifier);
            }
            else {
                _this._snackBar.open(ERROR_MSG, 'Error', {
                    duration: 6000
                });
            }
        });
    };
    return RemarksComponent;
}());
export { RemarksComponent };
